<template>
  <div class="page-content">
    <!-- <template v-if="model.email || model.tel"> -->
    <h3>通讯地址：{{ model.addr || model.address }}</h3>
    <h3>举报电话：{{ model.tel }}</h3>

    <h3>邮箱：{{ model.email }}</h3>
    <!-- </template> -->
  </div>
</template>

<script>
import { getTousujubao } from "@/apis/lianzheng";

export default {
  data() {
    return {
      model: {},
    };
  },
  created() {
    this.getTousujubao();
  },
  methods: {
    async getTousujubao() {
      const { data } = await getTousujubao();
      this.model = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 100%;
  flex-direction: column;
  padding-top: 80px;
  h3 {
    font-size: 28px;
    font-size: var(--font-size-28);
    font-weight: 800;
    line-height: 40px;
    display: block;
    color: #303133;
    margin-bottom: 40px;
  }
}
</style>
